const CreateProject = {
  EN: {
    projectInformation: {
      title: 'Project information',
      name: 'Project name',
      projecttype: 'Project type',
    },
    usageInformation: {
      title: 'Usage information',
      package: 'Package',
      creationDate: 'Creation date',
      expirationDate: 'Expiration date',
      renew: 'Auto renew',
      upgrade: 'Upgrade',
      pay: 'Pay',
    },
  },
  TH: {
    projectInformation: {
      title: 'ข้อมูลโครงการ',
      name: 'ชื่อโครงการ',
      projecttype: 'ประเภทโครงการ',
    },
    usageInformation: {
      title: 'ข้อมูลการใช้งาน',
      package: 'แพ็คเกจ',
      creationDate: 'วันที่สร้าง',
      expirationDate: 'วันหมดอายุ',
      renew: 'ต่ออายุอัตโนมัติ',
      upgrade: 'อัพเกรด',
      pay: 'ซื้อ',
    },
  },
};

export default CreateProject;
